import { createFileRoute } from '@tanstack/react-router'
import { CompanySheet } from '@/features/admin/company-sheet'

export const Route = createFileRoute('/_authenticated/admin/company-sheet')({
  component: CompanySheet,
})
